import React from 'react'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import { OpenAPIView } from './OpenAPIView'
import { useCreateOpenAPIConfigurationMutation } from './queries/useCreateOpenAPIConfigurationMutation'
import { useDeleteOpenAPIConfigurationMutation } from './queries/useDeleteOpenAPIConfigurationMutation'
import { useOpenAPIConfigurationQuery } from './queries/useOpenAPIConfigurationQuery'

export const OpenAPIContainer = () => {
  const { open } = useModalContext()
  const { openAPIConfigurationQuery, invalidateOpenAPIConfigurationQuery } =
    useOpenAPIConfigurationQuery()
  const { createOpenAPIConfigurationMutation } = useCreateOpenAPIConfigurationMutation()
  const { deleteOpenAPIConfigurationMutation } = useDeleteOpenAPIConfigurationMutation()

  const user = openAPIConfigurationQuery.isSuccess
    ? openAPIConfigurationQuery.data.configuration
    : undefined

  const handleUserCreate = () => {
    createOpenAPIConfigurationMutation.mutate([], {
      onSuccess: () => {
        invalidateOpenAPIConfigurationQuery()
      },
    })
  }

  const handleUserRemove = () => {
    open(ConfirmModal, {
      title: `Are you sure that you want to remove API User?`,
      confirmLabel: 'Remove',
      confirmAppearance: 'destructive',
      onConfirm: () => {
        deleteOpenAPIConfigurationMutation.mutate([], {
          onSuccess: () => {
            invalidateOpenAPIConfigurationQuery()
          },
        })
      },
    })
  }

  return (
    <OpenAPIView
      user={user}
      isLoading={
        createOpenAPIConfigurationMutation.isLoading || deleteOpenAPIConfigurationMutation.isLoading
      }
      onUserCreate={!openAPIConfigurationQuery.isLoading ? handleUserCreate : undefined}
      onUserRemove={handleUserRemove}
    />
  )
}
